<template>
  <el-container id="footer">
    <el-footer height="280px">
      <el-row>
        <div class="footer-content">
          <div style="width: 45%; float:left; margin-top:20px;">
            <span style="color: #a3a3ad;">• 指数制作方</span>
            <span style="color: #ffffff; margin-left: 10px;"><a href="http://www.dmg.fudan.edu.cn/" style="color: #ffffff;">复旦大学数字与移动治理实验室</a></span>
            <br>
            <div style="margin-top: 10px;">
              <a href="#" style="margin-left: 20px;">
                <img src="@/assets/images/logo-trans-dmg.png" width="240" height="50">
              </a>
              <a href="#" style="margin-left: 60px;">
                <img src="@/assets/images/dmg-qr-wechat.png" width="63">
                <br>
                <span style="color: #a3a3ad; margin-left: 325px;">微信公众号</span>
              </a>
            </div>
            <span style="color: #a3a3ad;">• 联系邮箱</span>
            <span style="color: #ffffff; margin-left: 10px;">dmglab@fudan.edu.cn</span>
            <br>
            <span style="color: #a3a3ad; line-height: 2.5;">• 联系电话</span>
            <span style="color: #ffffff; margin-left: 10px;">021-65643086</span>
          </div>
          <div style="width: 45%; float:left; margin-top:20px;">
            <span style="color: #a3a3ad;">• 合作方</span>
            <span style="color: #ffffff; margin-left: 36px;">冥睿（上海）信息科技有限公司</span>
            <br>
            <span style="color: #ffffff; margin-left: 84px;">中山大学数字治理研究中心</span>
            <br>
            <span style="color: #ffffff; margin-left: 84px;">晴禾（南京）文化有限公司 </span>
            <br>
            <span style="color: #ffffff; margin-left: 84px;">复旦发展研究院 </span>
          </div>
          <div style="width: 45%; float:left; margin-top:20px;">
            • 本网站是国家社科基金重大项目“面向数字化发展的公共数据开放利用体系与能力建设研究”<br>(批准号: 21&ZD337) 的阶段性成果
          </div>
          <div style="width: 45%; float:left; margin-top: 20px;">
            • 本数据库版权为复旦大学数字与移动治理实验室（复旦 DMG）所有，如需引用本数据库内容，请参照以下规范： 复旦大学数字与移动治理实验室 . 中 国 开 放 数 林 指 数 网 - 数林四库 [DB/OL]. (2021-08-02)[ 引用日期 ]. http://4cool.ifopendata.cn.
          </div>
        </div>
        <div class="footer-beian">
          <a href="https://beian.miit.gov.cn/" style="color:#a3a3ad; font-size: 10px;">沪ICP备19004396号-3</a><span>&nbsp;&nbsp;&nbsp;&nbsp;Copyright © 2021复旦大学数字与移动治理实验室版权所有 </span>
        </div>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>

<style scoped>
#footer {
  color: #ffffff;
  background: #393a50;
  line-height: 1.5;
}
#footer a {
  outline: 0;
  text-decoration: none;
}
#footer footer {
  padding: 25px 20px 10px 10px;
  width: 100%;
}
#footer .footer-content {
  font-size: 12px;
  padding: 10px 0 20px 5px;
  margin-left: 10%;
  margin-right: 10%;
  border-bottom: 1px solid #a3a3ad;
  width: 80%;
  height: 195px;
}
#footer .footer-content .footer-line-logo {
  margin-left: 1%;
}
#footer .footer-content .footer-dmgqr {
  float: right;
  font-size: 12px;
  color:#a3a3ad;
}
#footer .footer-coop {
  color: #a3a3ad;
  margin-top: 35px;
}
#footer .footer-coop .coop-line {
  margin-top: 10px;
}
#footer .footer-coop .coop-line .title {
  color: #a3a3ad;
}
#footer .footer-coop .coop-line .content {
  color: #ffffff;
}
#footer .footer-beian {
  margin-top: 13px;
  margin-left: 10%;
  margin-right: 10%;
  width: 80%;
  padding: 0 0 0 10px;
  font-size: 10px;
  color: #a3a3ad;
}
#footer .footer-beian p {
  margin-top:15px;
}
#footer .footer-beian a {
  color: #a3a3ad;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/Footer.vue